import { CONTENT_TYPES } from '@hivebrite/design-system/ContentList';

import type { ContentRecommendationResponseItem } from 'hb-react/shared/components/ContentRecommendation/hooks/useGetContentRecommendation';

export const formatContentRecommendationData = (
  item: ContentRecommendationResponseItem,
) => {
  switch (item.content_type) {
    case CONTENT_TYPES.NEWS:
      return {
        ...item,
        externalUrl: item.external_url,
        image: item.cover,
      };
    default:
      return item;
  }
};
